import { createTheme } from '@mui/material/styles';

export const PRIMARY = '#135F93';
export const SECONDARY = '#2F8EBD';
export const SOFT_TINT = '#E4F0F9';
export const PRIMARY_LIGHT = '#E4F0F9';
export const PRIMARY_DARK = '#0E4A75';
export const PRIMARY_BORDER = '#B3D3E8';
export const INK = '#0F172A';
export const MUTED = '#64748B';

export const GRADIENT = 'linear-gradient(135deg, #135F93 0%, #2F8EBD 100%)';
export const GRADIENT_SOFT = 'linear-gradient(135deg, #0E4A75 0%, #135F93 60%, #2F8EBD 100%)';

// Colours saved before the blue rebrand (entity / role accents) may still be
// purple. Map any violet-hued value to the primary so old data matches the theme.
export const brandColor = (c) => {
    const m = /^#?([0-9a-f]{6})$/i.exec(String(c || '').trim());
    if (!m) return c || PRIMARY;
    const [r, g, b] = [0, 2, 4].map((i) => parseInt(m[1].slice(i, i + 2), 16) / 255);
    const mx = Math.max(r, g, b), mn = Math.min(r, g, b), d = mx - mn;
    if (d < 0.1) return c;
    let h = mx === r ? ((g - b) / d) % 6 : mx === g ? (b - r) / d + 2 : (r - g) / d + 4;
    h = ((h * 60) + 360) % 360;
    return h >= 245 && h <= 300 ? PRIMARY : c;
};

const theme = createTheme({
    palette: {
        primary: {
            main: PRIMARY,
            light: PRIMARY_LIGHT,
            dark: PRIMARY_DARK,
            contrastText: '#ffffff',
        },
        secondary: {
            main: SECONDARY,
            light: SOFT_TINT,
            contrastText: '#ffffff',
        },
        background: {
            default: '#F6F8F9',
            paper: '#ffffff',
        },
        text: {
            primary: INK,
            secondary: MUTED,
        },
    },
    shape: { borderRadius: 7 },
    typography: {
        fontFamily: `'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif`,
        button: { textTransform: 'none', fontWeight: 700 },
    },
    components: {
        MuiButton: {
            defaultProps: { disableElevation: true },
            styleOverrides: {
                root: { borderRadius: 7, boxShadow: 'none', fontWeight: 700 },
                contained: {
                    background: PRIMARY_LIGHT,
                    color: PRIMARY,
                    border: '1px solid #B3D3E8',
                    boxShadow: 'none',
                    '&:hover': { background: '#D0E5F3', boxShadow: 'none' },
                    '&.Mui-disabled': { background: PRIMARY_LIGHT, color: PRIMARY, opacity: 0.5 },
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: { backgroundImage: 'none' },
            },
        },
    },
});

export default theme;
